// server.config.js

module.exports = {
  dealerRef: 'MT001',
  dealerFloor: 'DIGITAL',
  source: 'MT-DEALERWEBSITE',
};